const strings = {
  NEW_TIME: 'Skapa en ny tid',
  NEW_TIME_INFORMATION:
    'Ställ in en start -och sluttid för att skapa en ny bokningsbar tid.',
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  TIME_CREATED: 'Tiden har skapats',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/NewBookableTimeModal/strings.js